import React from 'react';
import { ToastContainer } from 'react-toastify';

const MessagesComponent = () => (
  <ToastContainer position="bottom-right" draggable autoClose={2000} draggablePercent={30} />
);

export default MessagesComponent;
